import React from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import isMobile from '../../../../utils/isMobile.js';
import {getUUID} from '../../../../utils/getUUID';
import {each} from 'lodash';

export default class BaseCell extends React.Component {
  static propTypes = {
    baseParams: PropTypes.object.isRequired,
    isBot: PropTypes.bool.isRequired,
    withIcon: PropTypes.bool.isRequired,
    time: PropTypes.string.isRequired,
    iconSrc: PropTypes.string,
    withoutDate: PropTypes.bool,
    textCountMax: PropTypes.number,
    textCountMin: PropTypes.number,
  }

  static mobileTextCopyState = {
    showMessageContentWrapper: false,
    showMessageContentWrapperTimerId: null,
    userSelectDisabled: true
  }

  constructor (props) {
    super(props);
  }

  messageClass(isBot) {
    const { isContinuous, fontSize } = this.props;
    return classNames(
      'cu-ui-message',
      {
        'cu-ui-message-bot': isBot,
        'cu-ui-message-user': !isBot,
        'cu-ui-message-is-continuous': isContinuous,
        'cu-ui-font-size-default': fontSize === 'default',
        'cu-ui-font-size-large': fontSize === 'large'
      }
    );
  }

  messageContentClass (option = {}) {
    const { enableMobileTextCopy } = this.props;
    const { userSelectDisabled } = this.state;
    return classNames('cu-ui-message-content', {
      'text-copy-enabled': isMobile() && enableMobileTextCopy,
      'user-select-disabled': isMobile() && userSelectDisabled,
      ...option
    });
  }

  getCellStyle({isBot, baseParams, iconSrc}) {
    const textCellStyle = {};
    const avatarStyle = {};

    // For bots
    if (isBot && baseParams.botPromptBackgroundColor) {
      textCellStyle['color'] = baseParams.botPromptColor;
      textCellStyle['backgroundColor'] = baseParams.botPromptBackgroundColor;
      textCellStyle['border'] = `1px solid ${baseParams.botPromptBackgroundColor}`;
      avatarStyle['backgroundColor'] = baseParams.botPromptBackgroundColor;
    }
    // For clients
    else if (!isBot && baseParams.clientPromptBackgroundColor) {
      textCellStyle['color'] = baseParams.clientPromptColor;
      textCellStyle['backgroundColor'] = baseParams.clientPromptBackgroundColor;
      textCellStyle['border'] = 'none';
      avatarStyle['backgroundColor'] = baseParams.clientPromptBackgroundColor;
    }
    if (!isBot) {
      textCellStyle['border'] = 'none';
    }
    if (iconSrc && iconSrc.length > 0) {
      avatarStyle['backgroundImage'] = `url(${iconSrc})`;
    }

    return {
      textCellStyle,
      avatarStyle
    };
  }

  getButtonStyle (baseParams) {
    return {
      backgroundColor: baseParams.clientPromptBackgroundColor,
      color: baseParams.clientPromptColor,
    };
  }

  /* -------------------- text counter -------------------- */
  get textCountCustomAttributes () {
    return {
      'data-text_count_max': this.props.textCountMax,
      'data-text_count_min': this.props.textCountMin
    };
  }

  /* -------------------- mobile text copy -------------------- */
  showMessageContentWrapperD = (e) => {
    const parents = e.target.closest('.cu-ui-button');
    if (parents) return;

    const timerId = setTimeout(() => {
      this.setState({ showMessageContentWrapper: true });
    }, 500);
    this.setState({ showMessageContentWrapperTimerId: timerId });
    document.addEventListener("touchstart", this.documentTouchHandler);
  }

  hideMessageContentWrapper = (e) => {
    this.clearShowMessageContentWrapperD(e);
    this.setState({ showMessageContentWrapper: false, userSelectDisabled: true });
    document.removeEventListener("touchstart", this.documentTouchHandler);
  }

  documentTouchHandler = (e) => {
    const parents = e.target.closest('.cu-ui-message-content__wrapper__button');
    // Need to early return here is this tap is on message content wrapper button,
    // so that it can proceed with next process like showing modal popup
    if (parents) return;

    this.hideMessageContentWrapper(e);
  }

  clearShowMessageContentWrapperD = (e) => {
    clearTimeout(this.state.showMessageContentWrapperTimerId);
  }

  executeCopy = (e, element) => {
    this.setState({ userSelectDisabled: false }, () => {
      const range = document.createRange();
      range.selectNodeContents(element);

      const selection = getSelection();
      selection.removeAllRanges();
      selection.addRange(range);

      window.document.execCommand('copy');
      selection.removeAllRanges();
      this.props.onOpenModalDialog(this.props.systemMessages.textCopyCompleted);
      this.hideMessageContentWrapper(e);
    });
  }
}
